import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../api';

const DocumentRepo = () => {
    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(true);

    const ICONS = {
        folder: <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>,
        file: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>,
        download: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
    };

    useEffect(() => {
        const fetchDocs = async () => {
            try {
                const token = localStorage.getItem('token');
                const res = await axios.get(`${API_BASE_URL}/api/documents`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setDocs(res.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchDocs();
    }, []);

    return (
        <div style={{ fontFamily: '"Outfit", sans-serif', maxWidth: '1400px', margin: '0 auto', padding: '20px' }}>
            <div style={{ marginBottom: '45px' }}>
                <h1 style={{ margin: '0 0 10px 0', fontSize: '32px', fontWeight: '800', color: '#2C1A10', letterSpacing: '-1px' }}>
                    Document Repository
                </h1>
                <p style={{ margin: 0, color: '#999', fontSize: '16px', fontWeight: '500' }}>
                    Secure archival of legislative sessions, notices, and procedural records.
                </p>
            </div>

            <div style={{ background: '#fff', borderRadius: '32px', border: '1px solid #F0E8DB', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.03)', minHeight: '500px', display: 'flex', flexDirection: 'column' }}>
                <div style={{ padding: '25px 40px', background: '#FDF8F3', borderBottom: '1px solid #F0E8DB' }}>
                    <h3 style={{ fontSize: '12px', color: '#C0722C', margin: 0, textTransform: 'uppercase', fontWeight: '900', letterSpacing: '1.5px' }}>System Archive Files</h3>
                </div>

                {loading ? (
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#C0722C', fontWeight: '700' }}>Accessing Mainframe Archive...</div>
                ) : docs.length === 0 ? (
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '100px 40px', textAlign: 'center' }}>
                        <div style={{ width: '100px', height: '100px', backgroundColor: '#FDF8F3', borderRadius: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#C0722C', marginBottom: '25px' }}>
                            {ICONS.folder}
                        </div>
                        <h3 style={{ margin: '0 0 10px 0', fontSize: '22px', fontWeight: '800', color: '#2C1A10' }}>No Records Detected in Registry</h3>
                        <p style={{ margin: 0, color: '#999', fontSize: '16px', fontWeight: '500', maxWidth: '400px' }}>The central legislative archive is currently empty for this session.</p>
                    </div>
                ) : (
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead style={{ background: '#FDF8F3' }}>
                            <tr>
                                <th style={{ padding: '20px 40px', textAlign: 'left', fontSize: '12px', fontWeight: '900', color: '#999', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Document Identity</th>
                                <th style={{ padding: '20px 40px', textAlign: 'left', fontSize: '12px', fontWeight: '900', color: '#999', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Classification</th>
                                <th style={{ padding: '20px 40px', textAlign: 'left', fontSize: '12px', fontWeight: '900', color: '#999', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Revision</th>
                                <th style={{ padding: '20px 40px', textAlign: 'left', fontSize: '12px', fontWeight: '900', color: '#999', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Timestamp</th>
                                <th style={{ padding: '20px 40px', textAlign: 'right', fontSize: '12px', fontWeight: '900', color: '#999', textTransform: 'uppercase', letterSpacing: '1.5px' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {docs.map((doc, idx) => (
                                <tr key={doc._id} style={{ borderBottom: idx === docs.length - 1 ? 'none' : '1px solid #FDF8F3', transition: 'background 0.2s' }} onMouseOver={(e) => e.currentTarget.style.background = '#F9F9F9'} onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}>
                                    <td style={{ padding: '25px 40px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <div style={{ color: '#C0722C' }}>{ICONS.file}</div>
                                            <div style={{ fontWeight: '800', color: '#2C1A10', fontSize: '16px' }}>{doc.title}</div>
                                        </div>
                                    </td>
                                    <td style={{ padding: '25px 40px' }}>
                                        <span style={{ padding: '6px 14px', background: '#F0E8DB', color: '#2C1A10', borderRadius: '10px', fontSize: '12px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            {doc.category}
                                        </span>
                                    </td>
                                    <td style={{ padding: '25px 40px', fontSize: '14px', color: '#888', fontWeight: '600' }}>v{doc.version || '1.0'}</td>
                                    <td style={{ padding: '25px 40px', fontSize: '14px', color: '#888', fontWeight: '500' }}>{new Date(doc.uploadDate).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}</td>
                                    <td style={{ padding: '25px 40px', textAlign: 'right' }}>
                                        <a
                                            href={doc.url}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                padding: '12px 20px',
                                                background: '#2C1A10',
                                                color: '#fff',
                                                borderRadius: '14px',
                                                fontSize: '13px',
                                                fontWeight: '800',
                                                textDecoration: 'none',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#C0722C'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                                            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#2C1A10'; e.currentTarget.style.transform = 'translateY(0)'; }}
                                        >
                                            {ICONS.download}
                                            Access File
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default DocumentRepo;
